import React, { useEffect, useState } from "react"
import axios from "axios"
import config from "../../config";
import { Link } from "react-router-dom"
import { Row, Col, Card, CardBody, CardHeader, Table } from "reactstrap"
import { TourProvider, useTour } from '@reactour/tour'

// Editable
// import BootstrapTable from "react-bootstrap-table-next"
// import cellEditFactory from "react-bootstrap-table2-editor"

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb'
//Import Breadcrumb
import { FaEye, FaMoneyBill } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import FormUpload from "../../components/Common/FormUpload"
import ClipLoader from "react-spinners/ClipLoader"


const products = [
  { id: 1, name: "David McHenry", age: 25, qty: 1500, cost: 1000 },
  { id: 2, name: "Frank Kirk", age: 34, qty: 1900, cost: 1300 },
  { id: 3, name: "Rafael Morales", age: 67, qty: 1300, cost: 1300 },
  { id: 4, name: "Mark Ellison", age: 23, qty: 1100, cost: 6400 },
  { id: 5, name: "Minnie Walter", age: 78, qty: 1400, cost: 4000 },
]

const columns = [
  {
    dataField: "id",
    text: "ID",
  },
  {
    dataField: "name",
    text: "Name",
  },
  {
    dataField: "age",
    text: "Age(AutoFill)",
  },
  {
    dataField: "qty",
    text: "Qty(AutoFill and Editable)",
  },
  {
    dataField: "cost",
    text: "Cost(Editable)",
  },
]

const EditableTables = () => {

  const token = localStorage.getItem('authUser');
  const [compliances, setCompliances] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCompliances = () => {
      axios
        .get(`${config.apiUrl}/api/compliances/`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
        .then((response) => {
          // console.log(response)
          setLoading(false);
          setCompliances(response.data);
        })
        .catch((error) => {
          // setError(error);
          setLoading(true);
        });
    };

    fetchCompliances();
  }, []);

  const fetchDelete = (id) => {
    axios
      .delete(`${config.apiUrl}/api/compliance/${id}/`, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      })
      .then(() => {
        location.href = '/compliance'
      })
      .catch((error) => {
        // setError(error);
        // setLoading(true);
      });
  };

  //meta title
  document.title = "Compliances | Zayon";

  // const { setIsOpen } = useTour()

  // console.log(compliances?  .length)


  return (
    <React.Fragment>
      <div className="step1 position-absolute z-n1"></div>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Dashboard" breadcrumbItem="Compliances" />

          <FormUpload />
          {
            compliances?.length == 0 ?
              <div className="text-center">
                <h6>Nenhuma análise encontrada, envie seus arquivos para começarmos...</h6>
              </div> :
              <Row className="step2">
                <Col>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        {/* <th>Título</th> */}
                        <th>Data realizada</th>
                        <th>Usuário</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                      {
                        compliances?.map((item, index) => (
                          <tr key={index} className="text-danger">
                            <th scope="row" className={index == 0 ? 'bg-success bg-opacity-50' : ''}>{compliances.length - index}</th>
                            <td className={index == 0 ? 'bg-success bg-opacity-50' : ''}>{item.created_at}</td>
                            <td className={`text-orange font-bold ${index == 0 ? 'bg-success bg-opacity-50' : ''}`}>{item.user_name}</td>
                            <td className={`d-flex gap-2 ${index == 0 ? 'bg-success bg-opacity-50' : ''}`}>
                              <Link to={index == 0 ? '/dashboard' : `/demo?id=${item.id}`}>
                                <button className='border-0 bg-primary text-white rounded'>
                                  <FaEye size={16} />
                                </button>
                              </Link>
                              <Link onClick={() => {
                                fetchDelete(item.id)
                              }}>
                                <button className='border-0 bg-danger text-white rounded'>
                                  <MdDeleteForever size={16} />
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))}

                    </tbody>
                  </Table>
                </Col>
              </Row>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditableTables
